import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const FooterContainer = styled(motion.footer)`
  padding: 40px 20px;
  text-align: center;
  background: linear-gradient(135deg, rgba(255, 192, 203, 0.8) 0%, rgba(255, 182, 193, 0.8) 100%);
  position: relative;
  z-index: 2;
  margin-top: 2rem;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  box-shadow: 0 -5px 20px rgba(255, 105, 180, 0.2);
`;

const HeartIcon = styled(motion.div)`
  width: 30px;
  height: 30px;
  background-color: #ff4b8d;
  display: inline-block;
  transform: rotate(45deg);
  margin: 0 10px;
  position: relative;
  
  &:before,
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #ff4b8d;
    border-radius: 50%;
  }
  
  &:before {
    top: -50%;
    left: 0;
  }
  
  &:after {
    top: 0;
    left: -50%;
  }
`;

const Message = styled.p`
  font-size: 1.2rem;
  color: #333;
  line-height: 1.6;
  margin: 1.5rem 0;
  max-width: 600px;
  margin: 1.5rem auto;
`;

const FinalMessage = styled(motion.h3)`
  font-size: 1.8rem;
  font-weight: 700;
  color: #fff;
  margin: 2rem 0 0.5rem;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
`;

const Signature = styled(motion.p)`
  font-size: 1.4rem;
  color: #fff;
  margin-top: 0.5rem;
  font-weight: 500;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
`;

const FloatingEmoji = styled(motion.div)`
  position: absolute;
  font-size: 2rem;
  top: ${props => props.top || '20px'};
  left: ${props => props.left};
  right: ${props => props.right};
`;

const Footer = () => {
  return (
    <FooterContainer
      initial={{ y: 50, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <FloatingEmoji
        top="30px"
        left="10%"
        animate={{
          y: [0, -10, 0],
          rotate: [0, 10, 0]
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        🌸
      </FloatingEmoji>
      
      <FloatingEmoji
        top="20px"
        right="10%"
        animate={{
          y: [0, -15, 0],
          rotate: [0, -10, 0]
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          repeatType: "reverse",
          delay: 0.5
        }}
      >
        🌹
      </FloatingEmoji>
      
      <HeartIcon
        animate={{
          scale: [1, 1.2, 1],
          rotate: [45, 45, 45],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />
      
      <Message>
        دلآرام عزیزم، امیدوارم این صفحه کوچک باعث شده باشد که لبخندی روی لبانت بنشیند و کمی از درد این روزهایت کم شده باشد.
        همیشه بدان که من کنارت هستم و با تمام وجود دوستت دارم.
      </Message>
      
      <FinalMessage
        animate={{
          y: [0, -5, 0],
          textShadow: [
            "1px 1px 3px rgba(0, 0, 0, 0.2)",
            "1px 1px 6px rgba(0, 0, 0, 0.4)",
            "1px 1px 3px rgba(0, 0, 0, 0.2)"
          ]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        زود خوب شو دلآرام عزیزم
      </FinalMessage>
      
      <Signature
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 1 }}
      >
        
      </Signature>
    </FooterContainer>
  );
};

export default Footer; 